<template>
  <div class="common-drag-panel panel-primary" ref="panelRef">
    <div class="header-box" @mousedown="handleDragStart">
      <div class="title-box">
        <div class="icon-box">
          <icon-svg icon-class="ic-a-Dragthe" />
        </div>
        <div class="name-box">{{ title }}</div>
        <div v-if="tooltipVisible">
          <el-tooltip
            placement="top-start"
            :effect="$theme.tooltipKey()"
            popper-class="common-panel-tooltip-box"
          >
            <div slot="content">
              <span> 注： </span>
              <div>
                (1)
                纹理动画仅针对当前版本的模型有效，若模型需要频繁更新，建议在最新版本上进行编辑并应用。
              </div>
              <div>
                (2) 选择不连续的管道可能会出现异常情况，建议选择连续的管道。
              </div>
            </div>
            <div class="icon-box tooltip-icon-box">
              <icon-svg icon-class="ic-wenhao1" class="icon" />
            </div>
          </el-tooltip>
        </div>
      </div>
      <div class="close-icon-box" @click="closePanel">
        <i class="el-icon-close" />
      </div>
    </div>
    <div class="content" ref="content"><slot /></div>
    <div class="drag-resize" @mousedown="handleResizeStart">
      <icon-svg icon-class="ic-zhankaisuofang" class="icon" />
    </div>
  </div>
</template>

<script>
export default {
  name:'dragPanel',
  data() {
    return {
      isDragEnable: false,
      isResizeEnable: false,
    };
  },
  props: {
    title: String,
    tooltipVisible: Boolean,
    // 限制拖拽区域(left: 只在左半屏拖拽, right: 只在右半屏拖拽, 为空则不限制)
    limitDragArea: String,
    closePanel: Function,
  },
  methods: {
    handleDragStart(event) {
      this.isDragEnable = true;
      this.startX = event.clientX - this.$refs.panelRef.offsetLeft;
      this.startY = event.clientY - this.$refs.panelRef.offsetTop;

      document.addEventListener("mousemove", this.onMouseMove);
      document.addEventListener("mouseup", this.onMouseUp);
    },
    onMouseMove(event) {
      const dom = this.$refs.panelRef;
      const parentDom = this.$refs.panelRef.parentElement;
      if (this.isDragEnable) {
        let minLeft = 0;
        let maxLeft = parentDom.clientWidth - dom.offsetWidth;
        if (this.limitDragArea === "left") {
          maxLeft = parentDom.clientWidth / 2 - dom.offsetWidth;
        }
        if (this.limitDragArea === "right") {
          minLeft = parentDom.clientWidth / 2;
        }
        const maxTop = parentDom.clientHeight - dom.offsetHeight;

        let newLeft = event.clientX - this.startX;
        let newTop = event.clientY - this.startY;

        // 限制元素移动的范围
        if (newLeft < minLeft) {
          newLeft = minLeft;
        }
        if (newTop < 0) {
          newTop = 0;
        }
        if (newLeft > maxLeft) {
          newLeft = maxLeft;
        }
        if (newTop > maxTop) {
          newTop = maxTop;
        }

        dom.style.left = newLeft + "px";
        dom.style.top = newTop + "px";
      }

      if (this.isResizeEnable) {
        dom.style.left = dom.offsetLeft + "px";

        const minWidth = 200;
        const minHeight = 150;

        let mouseX = event.clientX;
        let mouseY = event.clientY;
        let boxX = dom.getBoundingClientRect().left;
        let boxY = dom.getBoundingClientRect().top;

        let newWidth = mouseX - boxX + 6;
        let newHeight = mouseY - boxY + 6;
        newWidth = newWidth > minWidth ? newWidth : minWidth;
        newHeight = newHeight > minHeight ? newHeight : minHeight;

        dom.style.width = newWidth + "px";
        dom.style.height = newHeight + "px";
      }
    },
    onMouseUp(e) {
      this.isDragEnable = false;
      this.isResizeEnable = false;
      document.removeEventListener("mousemove", this.onMouseMove);
      document.removeEventListener("mouseup", this.onMouseUp);
    },
    handleResizeStart(e) {
      this.isResizeEnable = true;
      document.addEventListener("mousemove", this.onMouseMove);
      document.addEventListener("mouseup", this.onMouseUp);
    },
  },
};
</script>

<style lang="less" scoped>
.common-drag-panel {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 3;

  .icon-box{
    margin-left: -4px;
  }

  .name-box{
    margin-right: 6px;
  }
  .close-icon-box{
    &:hover,
    &:active{
      background-color: var(--base-bg-dark-color33);
      border-radius: 4px;
    }
  }

  .drag-resize {
    position: absolute;
    width: 8px;
    height: 8px;
    bottom: 11px;
    right: 10px;
    cursor: nw-resize;
  }
}
</style>